import React from 'react'

import { useNotification } from '@notification/context/NotificationContext'
import { TYPE_TO_COLOR } from '@model/constants'

import css from './Alert.module.css'
import { Button } from '@/shared/components/common/Button/Button'

export const Alert: React.FC = () => {
  const { alerts, removeAlert } = useNotification()

  return (
    <>
      {['top', 'bottom'].map((position) => (
        <div
          key={position}
          className={css[`alert-container`] + ' ' + css[`alert-container--${position}`]}
        >
          {alerts.filter(a => (a.position ?? 'top') === position).map(alert => (
            <div
              key={alert.id}
              className={css.alert + ' ' + css[`alert--${alert.type}`]}
              style={{ background: TYPE_TO_COLOR[alert.type] }}
            >
              {alert.message}
              {((alert.onConfirm || alert.onCancel)) && (
                <div className={css.alertActions}>
                  {alert.onConfirm && (
                    <Button
                      variant={alert.confirmButtonVariant || 'success'}
                      onClick={() => {
                        alert.onConfirm && alert.onConfirm();
                        removeAlert(alert.id);
                      }}
                    >
                      {alert.confirmText || 'Подтвердить'}
                    </Button>
                  )}
                  {alert.onCancel && (
                    <Button
                      variant={alert.cancelButtonVariant || 'danger'}
                      onClick={() => {
                        alert.onCancel && alert.onCancel();
                        removeAlert(alert.id);
                      }}
                    >
                      {alert.cancelText || 'Отмена'}
                    </Button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </>
  )
} 